import { jsx as _jsx } from "react/jsx-runtime";
import { FunctionalLoader } from 'seagull';
import { BootRetryScreen } from '~/components/BootRetryScreen/BootRetryScreen';
import { useIoContext } from '~/contexts';
import { useBootStalled } from '~/hooks/useBootStalled';
import { useLocaleKeys } from '~/i18n';
import { NETWORK_RETRY_SCHEDULE } from '~/utils/networkRetry/network-retry-schedule';
import { useBootNetworkRetry } from './hooks/useBootNetworkRetry';
export const BeforeAuthFlowDone = (param)=>{
    let { stalledAfterMs, retrySchedule = NETWORK_RETRY_SCHEDULE } = param;
    const bootStalled = useBootStalled(stalledAfterMs);
    const networkRetry = useBootNetworkRetry(retrySchedule);
    const { t } = useLocaleKeys('common.bootRetry');
    const { browser: { locationReload } } = useIoContext();
    if (networkRetry.isActive) {
        return /*#__PURE__*/ _jsx(BootRetryScreen, {
            biName: "boot_network_retry",
            onRetry: ()=>networkRetry.retryNow(),
            title: t.networkFailure.title(),
            body: t.networkFailure.body(),
            caption: networkRetry.isRetrying ? t.networkFailure.retrying() : t.networkFailure.retryingIn({
                seconds: networkRetry.secondsLeft
            }),
            retryLabel: t.networkFailure.retryNow()
        });
    }
    if (bootStalled) {
        return /*#__PURE__*/ _jsx(BootRetryScreen, {
            biName: "boot_stalled_retry",
            onRetry: locationReload,
            title: t.title(),
            body: t.body(),
            retryLabel: t.retry()
        });
    }
    return /*#__PURE__*/ _jsx(FunctionalLoader, {
        name: "waitForAuthFlowDone",
        show: true
    });
};
